import React, { Component } from "react";
import { getCall } from "../../../api/post";
import {
  getImageUrl,
  getPlaceHolderImage,
  getSettingUrl,
  getMerchantInformationUrl,
  getMasterDetailsIdUrl,
  getAddressDetailUrl,
} from "../../../services";
import { connect } from "react-redux";
import {
  loadUserDetailsFromLocalStorage,
  getValueFromLanguageObject,
  getCurrencySymbol,
  formatPrice,
} from "../../../store";
import MainLoader from "../../../animation/MainLoader";
import ErrorMessageAnimationModal from "../../../animation/ErrorMessageAnimationModal";
import {
  clearLocalStorageReload,
  isOpenStoreIdExist,
  navigateTo,
  removeUserDetailAndOtherDetails,
} from "../../../utils/utils";
import { withRouter } from "react-router-dom";
import Lightbox from "react-image-lightbox";

class OrderSummary extends Component {
  state = {
    orderId: this.props.match.params.id,
    orderSummary: {},
    isLoading: true,
    isMerchantGSTEnable: false,
    merchantInfo: {},
    currentCatelogueType: {},
    showErrorMessageModal: false,
    errorMessage: "",
    masterDetailsObj: {},
    isFullScreenImage: false,
    fullScreenImagePath: "",
  };

  componentDidMount() {
    const userDetails = loadUserDetailsFromLocalStorage();
    if (!isOpenStoreIdExist() && userDetails === undefined) {
      navigateTo(this.props, `/login`);
      return;
    }
    if (isOpenStoreIdExist()) {
      navigateTo(this.props, `/`);
      return;
    }
    this.initMasterDetailsId().then(() => {
      const { masterDetailsObj } = this.state;
      this.initOrderSummary().then(() => {
        this.setState({ isLoading: false });
      });
      this.initMerchantInfo();
      this.initCatelogueSettings();
      this.initAddressDetails();
    });
  }

  initMasterDetailsId = async () => {
    let masterDetailsObj = {};
    const publicUrl = window.location.pathname.split("/")[1];
    const masterDetailsIdUrl = getMasterDetailsIdUrl(publicUrl);
    const masterDetails = await getCall(masterDetailsIdUrl, []);
    if (masterDetails.error) {
      clearLocalStorageReload({ response: masterDetails });
    } else {
      if (masterDetails) {
        masterDetailsObj = masterDetails;
      }
    }
    this.setState({ masterDetailsObj });
  };

  initOrderSummary = async () => {
    const { orderId } = this.state;
    const orderSummaryUrl = `v2/orders/${orderId}`;
    const orderSummary = await getCall(orderSummaryUrl, []);
    if (orderSummary.error) {
      clearLocalStorageReload({ response: orderSummary });
      this.loadErrorMessageAnimation(orderSummary.error.message);
      if (orderSummary.error.statusCode === 401) {
        removeUserDetailAndOtherDetails();
        navigateTo(this.props, `/login`);
        return;
      }
    } else {
      this.setState({ orderSummary });
    }
  };

  initMerchantInfo = async () => {
    const { masterDetailsObj } = this.state;
    const merchantInfoUrl = getMerchantInformationUrl(masterDetailsObj);
    const merchantInfo = await getCall(merchantInfoUrl, []);
    if (merchantInfo.error) {
      clearLocalStorageReload({ response: merchantInfo });
      this.setState({ isMerchantGSTEnable: false, merchantInfo: {} });
    } else {
      this.setState({
        merchantInfo,
        isMerchantGSTEnable: merchantInfo.enablegst === 0 ? false : true,
      });
    }
  };

  initCatelogueSettings = async () => {
    const { masterDetailsObj } = this.state;
    const settingUrl = getSettingUrl(masterDetailsObj);
    const settingInfo = await getCall(settingUrl, []);
    if (settingInfo.error) {
      clearLocalStorageReload({ response: settingInfo });
    } else {
      let settings = {};
      settingInfo.forEach((setting) => {
        if (
          (setting.registerallow === "Catalogue_FMCG" ||
            setting.registerallow === "Catalogue_Jewellary" ||
            setting.registerallow === "Catalogue_Electronics" ||
            setting.registerallow === "Catalogue_FABRIC") &&
          setting.status === 1
        ) {
          settings = setting;
        }
      });
      this.setState({ currentCatelogueType: settings });
    }
  };

  initAddressDetails = async () => {
    const { masterDetailsObj } = this.state;
    const addressDetails = await getCall(
      getAddressDetailUrl(masterDetailsObj),
      []
    );
    if (addressDetails.error) {
      clearLocalStorageReload({ response: addressDetails });
    } else {
      if (addressDetails.length > 0) {
        this.setState({ addressDetails: JSON.parse(addressDetails[0].text) });
      }
    }
  };

  getTotalofCart(orderSummary) {
    let total = 0;
    if (orderSummary.orderdetail)
      for (let i = 0; i < orderSummary.orderdetail.length; i++) {
        total =
          total +
          orderSummary.orderdetail[i].amount *
            orderSummary.orderdetail[i].quantity;
      }
    return total;
  }

  getSubTotalFromTotalandServiceCharges = () => {
    const { orderSummary } = this.state || {};
    let subTotal = 0;
    const total = this.getTotalofCart(orderSummary);
    const serviceChargeAmount = 0; // No service charges in your response
    subTotal = total + serviceChargeAmount;
    return subTotal;
  };

  getCGSTFromTotal = (total) => {
    const { merchantInfo } = this.state;
    return (total * (merchantInfo.CGST || 0)) / 100;
  };
  getSGSTFromTotal = (total) => {
    const { merchantInfo } = this.state;
    return (total * (merchantInfo.SGST || 0)) / 100;
  };
  getIGSTFromTotal = (total) => {
    const { merchantInfo } = this.state;
    return (total * (merchantInfo.IGST || 0)) / 100;
  };

  getGrandTotal = (total, cgst, sgst, igst, shippingCharges) => {
    const { merchantInfo, currentCatelogueType } = this.state;
    var grandTotal = 0;
    if (!merchantInfo.enablegst || merchantInfo.enablegst === 0) {
      grandTotal = total + (shippingCharges || 0);
      return grandTotal;
    }
    if (
      merchantInfo.enablegst === 1 &&
      currentCatelogueType &&
      currentCatelogueType.registerallow === "Catalogue_Jewellary"
    ) {
      grandTotal = total + (shippingCharges || 0);
      return grandTotal;
    }
    if (merchantInfo.countryname === "India") {
      grandTotal = total + cgst + sgst + (shippingCharges || 0);
    } else {
      grandTotal = total + igst + (shippingCharges || 0);
    }
    return grandTotal;
  };

  renderBillingAddress = () => {
    const { orderSummary } = this.state;
    if (orderSummary && orderSummary.address) {
      let addressObj = {};
      try {
        addressObj = JSON.parse(orderSummary.address);
      } catch (e) {
        return null;
      }
      const billingArr = addressObj.billingaddress || [];
      if (billingArr.length === 0) return null;
      const billingAddress = billingArr[0];
      return (
        <ul className="order-detail">
          <li><b>Name:</b> {billingAddress.name}</li>
          <li><b>Mobile:</b> {billingAddress.phone}</li>
          <li><b>Address:</b> {billingAddress.addressline1}, {billingAddress.addressline2}</li>
          <li><b>City:</b> {billingAddress.city}</li>
          <li><b>State:</b> {billingAddress.state}</li>
          <li><b>Country:</b> {billingAddress.country}</li>
          <li><b>Zipcode:</b> {billingAddress.zipcode}</li>
        </ul>
      );
    }
    return null;
  };

  renderShippingAddress = () => {
    const { orderSummary } = this.state;
    if (orderSummary && orderSummary.address) {
      let addressObj = {};
      try {
        addressObj = JSON.parse(orderSummary.address);
      } catch (e) {
        return null;
      }
      const shippingArr = addressObj.shippingaddress || [];
      if (shippingArr.length === 0) return null;
      const shippingAddress = shippingArr[0];
      return (
        <ul className="order-detail">
          <li><b>Name:</b> {shippingAddress.name}</li>
          <li><b>Mobile:</b> {shippingAddress.phone}</li>
          <li><b>Address:</b> {shippingAddress.addressline1}, {shippingAddress.addressline2}</li>
          <li><b>City:</b> {shippingAddress.city}</li>
          <li><b>State:</b> {shippingAddress.state}</li>
          <li><b>Country:</b> {shippingAddress.country}</li>
          <li><b>Zipcode:</b> {shippingAddress.zipcode}</li>
        </ul>
      );
    }
    return null;
  };

  render() {
    const {
      orderSummary,
      isLoading,
      isMerchantGSTEnable,
      currentCatelogueType,
      showErrorMessageModal,
      errorMessage,
      masterDetailsObj,
      isFullScreenImage,
      fullScreenImagePath,
    } = this.state;
    const { symbol } = this.props;

    const subTotal = this.getSubTotalFromTotalandServiceCharges();

    return (
      <div>
        {/* <section className="section-b-space light-layout">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8">
                <div className="success-text text-center">
                  <h2 className="mb-3">
                    {getValueFromLanguageObject("str_thank_you")
                      ? getValueFromLanguageObject("str_thank_you")
                      : "Thank you"}
                  </h2>
                  <p className="lead">
                    {getValueFromLanguageObject("str_order_placed_successfully")
                      ? getValueFromLanguageObject("str_order_placed_successfully")
                      : "Order Placed Successfully"}
                  </p>
                  <p>
                    {getValueFromLanguageObject("order_id")
                      ? getValueFromLanguageObject("order_id")
                      : "Order ID"}
                    : <b>{orderSummary.orderno}</b>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section> */}

        <section className="section-b-space">
          <div className="container" style={{ marginTop: "80px" }}>
            <div className="row">
              <div className="col-lg-12">
                <div className="product-order order-success-sec">
                  <h4 className="f22 mb-4">
                    {getValueFromLanguageObject("str_your_order_details")
                      ? getValueFromLanguageObject("str_your_order_details")
                      : "Your order details"}
                  </h4>
                  {orderSummary.orderdetail &&
                    orderSummary.orderdetail.map((item, index) => (
                      <div className="row product-order-detail align-items-center mb-3" key={index}>
                        <div
                          className="col-12 col-sm-2"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            const path =
                              item.products.productmedia &&
                              item.products.productmedia.length > 0
                                ? getImageUrl(
                                    item.products.productmedia[0].productname,
                                    masterDetailsObj
                                  )
                                : getPlaceHolderImage();
                            this.setState({
                              isFullScreenImage: true,
                              fullScreenImagePath: path,
                            });
                          }}
                        >
                          <img
                            src={
                              item.products.productmedia &&
                              item.products.productmedia.length > 0
                                ? getImageUrl(
                                    item.products.productmedia[0].productname,
                                    masterDetailsObj
                                  )
                                : getPlaceHolderImage()
                            }
                            alt=""
                            className="img-fluid rounded"
                            style={{ maxHeight: 80, objectFit: "cover" }}
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = getPlaceHolderImage();
                            }}
                          />
                        </div>
                        <div className="col-12 col-sm-4 order_detail" style={{ display: "flex", flexDirection: "column" }}>
                          <h5 className="mb-1" style={{ marginBottom: "4px" }}>{item.products.name}</h5>
                          <div className="text-muted" style={{ marginBottom: "4px" }}>
                            {item.products.category && item.products.category.name}
                          </div>
                        </div>
                        <div className="col-6 col-sm-3 order_detail">
                          <div>
                            <span className="text-muted">Quantity:</span>
                            <span className="ml-2">{item.quantity}</span>
                          </div>
                        </div>
                        <div className="col-6 col-sm-3 order_detail">
                          <div>
                            <span className="text-muted">Price:</span>
                            <span className="ml-2">{formatPrice(item.amount)}</span>
                          </div>
                        </div>
                      </div>
                    ))}
                  <div className="total-sec mt-4">
                    <div className="final-total">
                      <h4>
                        {getValueFromLanguageObject("str_total")
                          ? getValueFromLanguageObject("str_total")
                          : "Total"}
                        <span className="ml-2">
                          {formatPrice(this.getTotalofCart(orderSummary))}
                        </span>
                      </h4>
                      <h4>
                        {getValueFromLanguageObject("amount_payable")
                          ? getValueFromLanguageObject("amount_payable")
                          : "Amount Payable"}
                        <span className="ml-2">
                          {formatPrice(
                            this.getGrandTotal(
                              subTotal,
                              0,
                              0,
                              0,
                              orderSummary.shippingprice
                            )
                          )}
                        </span>
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 mt-4">
                <div className="row order-success-sec">
                  <div className="col-lg-12 mb-4">
                    <h4 className="f22 mb-2">
                      {getValueFromLanguageObject("str_customer_detail")
                        ? getValueFromLanguageObject("str_customer_detail")
                        : "Customer Details"}
                    </h4>
                    <ul className="order-detail">
                      <li>
                        <b>Name:</b>{" "}
                        {orderSummary.orderuser &&
                          (orderSummary.orderuser.firstname
                            ? orderSummary.orderuser.firstname + " " + orderSummary.orderuser.lastname
                            : orderSummary.orderuser.username)}
                      </li>
                      <li>
                        <b>Mobile:</b>{" "}
                        {orderSummary.orderuser &&
                          orderSummary.orderuser.cellnumber}
                      </li>
                      <li>
                        <b>Email:</b>{" "}
                        {orderSummary.orderuser &&
                          orderSummary.orderuser.email}
                      </li>
                      {orderSummary.orderuser &&
                        orderSummary.orderuser.agentcode && (
                          <li>
                            <b>Agent Code:</b> {orderSummary.orderuser.agentcode}
                          </li>
                        )}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {isLoading && <MainLoader />}
        {showErrorMessageModal && (
          <ErrorMessageAnimationModal
            show={showErrorMessageModal}
            message={errorMessage}
            onClose={() => {
              this.setState({ showErrorMessageModal: false });
            }}
          />
        )}
        {isFullScreenImage && (
          <Lightbox
            mainSrc={fullScreenImagePath}
            onCloseRequest={() =>
              this.setState({
                isFullScreenImage: false,
                fullScreenImagePath: "",
              })
            }
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  symbol: getCurrencySymbol(),
});

export default connect(
  mapStateToProps,
  {}
)(withRouter(OrderSummary));
